module.exports = __webpack_public_path__ + "static/img/4.ddbd980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/4.png
// module id = sB4b
// module chunks = 0